
import { computed, defineComponent, ref, watch, onMounted, useStore } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'
import { setupGtmCdpAction, setupGtmCdpEvent } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    audioWorks: { type: Array, required: true },
    headerAudioIsPlaying: { type: Boolean, required: true },
    toggleHeaderAudio: { type: Function, required: true },
  },
  setup(props) {
    const store = useStore()
    const gtmCdpAction = setupGtmCdpAction()
    const { t_ } = setupTranslationPrefixer('AudioWorks')
    const showAll = ref(false)
    const annotatedAudioWorks = computed(() =>
      props.audioWorks.map((audioWork) => ({
        ...audioWork,
        extraLines: [audioWork.extraInfo, audioWork.encore ? t_('has-encore') : false].filter((value) => !!value),
      }))
    )
    const visibleAudioWorks = computed(() => (showAll.value ? annotatedAudioWorks.value : annotatedAudioWorks.value.slice(0, 4)))
    const playerStates = computed(() => store.getters['audio-player/playerStates'])
    const hasAudioFragments = annotatedAudioWorks.value.some(({ audio }) => audio)

    if (hasAudioFragments) {
      setupGtmCdpEvent('CV07 - Music fragment available')
    }

    const toggleShowAll = () => {
      showAll.value = !showAll.value
      if (showAll.value) {
        gtmCdpAction('CV07 - See all works clicked')
      }
    }

    const toggleAudio = (id) => {
      const isPlaying = computed(() => playerStates.value[id])
      if (!playerStates.value[id]) {
        gtmCdpAction('CV07 - Works music fragment clicked')
      }

      if (isPlaying.value) {
        gtmCdpAction('CV07 - Music fragment paused')
      }

      store.dispatch('audio-player/toggleAudio', id)
    }

    const lastAudioItem = computed(() => {
      return (
        props.audioWorks
          .slice()
          .reverse()
          .find((item) => item.audio !== null) || {}
      )
    })

    // TODO: ADD WATCHER FOR GTM Events
    onMounted(() => {
      watch(
        () => props.headerAudioIsPlaying,
        (newVal) => {
          if (newVal !== playerStates.value[lastAudioItem.value.id]) {
            store.dispatch('audio-player/toggleAudio', lastAudioItem.value.id)
          }
        }
      )
    })

    return {
      annotatedAudioWorks,
      visibleAudioWorks,
      playerStates,
      t_,
      toggleAudio,
      toggleShowAll,
      showAll,
    }
  },
})
